import React from "react";
import { Avatar, Group, Text } from "@mantine/core";
import ProgressIndicator from "../../../themes/components/ProgressIndicator";
import ErrorPage from "../../../common/pages/ErrorPage";
import DirectoryTable from "../../../themes/components/DirectoryTable";
import TagAssignee from "../services/model/TagAssignee";
import useTagDetailsApiService from "../services/api/TagDetailsApiService";
import { dateFormat } from "../../../utils/DateTime";
import TagAssigneeTableEmptyStateContainer from "./TagAssigneeTableEmptyStateContainer";
import EmployeeStatusBadge from "../../employees/elements/EmployeeStatusBadge";
import TagAssigneeFormDrawer from "./TagAssigneeFormDrawer";
import UnAssignTagActionIcon from "../elements/UnAssignTagActionIcon";

type TagAssigneeTableProps = {
  id: number;
  selection: TagAssignee[];
  onSelection: React.Dispatch<React.SetStateAction<TagAssignee[]>>;
  isFormDrawerOpen: boolean;
  toggleFormDrawer: React.Dispatch<React.SetStateAction<boolean>>;
};

const TagAssigneeTable: React.FC<TagAssigneeTableProps> = ({
  id,
  selection,
  onSelection,
  isFormDrawerOpen,
  toggleFormDrawer,
}) => {
  const { isLoading, isError, error, data } = useTagDetailsApiService(id);

  if (isLoading) {
    return <ProgressIndicator />;
  }

  if (isError) {
    return <ErrorPage errors={error} />;
  }

  if (!data) {
    return <TagAssigneeTableEmptyStateContainer id={id} />;
  }

  if (data && data.employees && !data.employees.length) {
    return <TagAssigneeTableEmptyStateContainer id={id} />;
  }

  return (
    <>
      <TagAssigneeFormDrawer
        id={id}
        opened={isFormDrawerOpen}
        onClose={() => toggleFormDrawer(false)}
        assignee={data.employees}
      />
      <DirectoryTable<TagAssignee>
        data={data.employees}
        selection={selection}
        onSelect={onSelection}
        headers={["Full name", "Date Added", "Email Address", "Status"]}
        rows={data.employees.map((it) => ({
          name: (
            <Group spacing="sm">
              <Avatar size={26} radius={26} />
              <Text size="sm">{`${it.first_name} ${it.last_name}`}</Text>
            </Group>
          ),
          date: dateFormat(it.date_created),
          email: it.email || "-",
          status: <EmployeeStatusBadge status={it.status} />,
          action: <UnAssignTagActionIcon  employeeId={it.id} tagId={id}/>
        }))}
      />
    </>
  );
};

export default TagAssigneeTable;
